import { Box, InputLabel } from "@mui/material";
import { debounce } from "lodash";
import { ColorPicker } from "mui-color";
import React from "react";
import { useTranslation } from "react-i18next";

const ColorPickerComponent = ({ color, setColor, isDisableAlpha = false }) => {
  const { t } = useTranslation();
  const [localColor, setLocalColor] = React.useState(color);
  
  const debounceColor = React.useCallback(
    debounce((e) => setColor(e), 300),
    [setColor]
  );

  React.useEffect(() => {
    setLocalColor(color);
  }, [color]);

  return (
    <Box my={2} id="color">
      <InputLabel shrink>{t("/editor.gui.color")}</InputLabel>
      <ColorPicker
        value={localColor}
        onChange={(e) => {
          setLocalColor(`#${e?.hex}`);
          !e.error && debounceColor(e.css.backgroundColor);
        }}
        hideTextfield
        disableAlpha={isDisableAlpha}
      />
    </Box>
  );
};

export default ColorPickerComponent; 